'use client'
import { Link } from '@repo/web-ui/components/link'
import { SkeletonItem } from 'components/skeleton-item'
import Image from 'next/image'

interface ClubhouseImageCardProps {
  children?: React.ReactNode
  image?: string
  href?: string
  isLoading?: boolean
}

export const ClubhouseImageCard = ({
  children,
  image,
  isLoading,
  href,
}: ClubhouseImageCardProps) => {
  return isLoading ? (
    <Skeleton />
  ) : (
    <div
      className="bg-cf-white h-auto w-full rounded-[4px] shadow-md"
      data-testid="clubhouse-image-card"
    >
      <div className="aspect-[3/2] w-full overflow-hidden rounded-t-[4px]">
        <Link href={href} target="_blank">
          <Image
            src={
              image ||
              `https://www.creativefabrica.com/wp-content/uploads/2023/08/25/CF-Classes-Update-Templates-2-580x387.png`
            }
            width={250}
            height={250}
            alt="cover"
            className="bg-cf-white h-full w-full overflow-hidden object-contain"
          />
        </Link>
      </div>
      <div className="h-auto w-full p-2">{children}</div>
    </div>
  )
}

const Skeleton = () => {
  return (
    <>
      <SkeletonItem className="h-[250px] w-full rounded-t-[4px]" />
      <div className="w-full p-2">
        <SkeletonItem className="w-full" />
        <SkeletonItem className="mt-1 w-full" />
      </div>
    </>
  )
}
